import { render, staticRenderFns } from "./QueueCard3.vue?vue&type=template&id=24d9a788&scoped=true&lang=pug"
import script from "./QueueCard3.vue?vue&type=script&lang=js"
export * from "./QueueCard3.vue?vue&type=script&lang=js"
import style0 from "./QueueCard3.vue?vue&type=style&index=0&id=24d9a788&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d9a788",
  null
  
)

export default component.exports